var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", { staticClass: "heading" }, [_vm._v("Technical Details")]),
    _vm._v(" "),
    _c("table", { staticClass: "technical-details" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.technicalDetails, function(detail, index) {
          return _c("tr", { key: index, class: detail.type }, [
            _c("td", { staticClass: "property", class: detail.type }, [
              _vm._v(_vm._s(detail.property))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "value", class: detail.type }, [
              _vm._v(_vm._s(detail.value))
            ])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Property")]),
        _vm._v(" "),
        _c("th", [_vm._v("Value")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }